import { Spin as SpinAnt } from 'antd';

const Spin = props => <SpinAnt tip='Loading...' {...props} />;
export default Spin;
